import { createSlice } from "@reduxjs/toolkit";

const initialUserState = {
  listLoading: false,
  actionsLoading: false,
  userList: [],
  user: undefined,
  userAuthToken: null,
  lastError: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.loading = false;
      } else {
        state.loading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.loading = true;
      } else {
        state.loading = true;
      }
    },
    init: (state, action) => {
      state.userList = [];
      state.user = undefined;
      state.userAuthToken = null;
    },
    userFetched: (state, action) => {
      state.actionsLoading = false;
      state.user = action.payload.user;
      state.error = null;
    },
    usersFetched: (state, action) => {
      const userList = action.payload;
      state.listLoading = false;
      state.error = null;
      state.userList = userList;
    },
  },
});
